import { NgxRolesService } from 'ngx-permissions';
import { Component, OnInit } from '@angular/core';
import { } from '@types/googlemaps';
import MarkerClusterer from '@google/markerclusterer';
import { AuthService } from '../../../services/auth.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
declare const google: any;
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'app-passenger-map',
  templateUrl: './passenger-map.component.html',
  styleUrls: ['./passenger-map.component.css']
})
export class PassengerMapComponent implements OnInit {
  filter = {
    schoolId: 0,
    busIds: [],
    history: false,
    date: null,
    journeyType: 'M1',
    journeyIds: [],
    inputFrom: '',
    inputTo: '',
    timeInterval: [],
    raduis: '40'
  };
  staticFilter: any;
  schools: any[];
  buses: any[];
  map: any;
  markerBounds: any;
  center: any;
  journeys: any[];
  directionsService: any;
  directionsRenderer: any;
  selectedZoneIndex: any;

  stopsRealArrivalTime : any[];
  stopsWaitingTime : any[];
  selectedPassengers : any[];
  markers : any[];
  stopsName : any[];
  withDirection = false;
  withZones =  false;
  

  showHistorique = false;
  loadData = false;
  onLoadFilter = true;
  reservedColors = [
    '#3498db',
    '#341f97',
    '#2ecc71',
    '#9b59b6',
    '#34495e',
    '#50000d',
    '#16a085',
    '#c0392b',
    '#34495e',
    '#000000',
  ];

  public schoolsData: Array<Select2OptionData>;
  public journeyTypeData: Array<Select2OptionData>;
  public raduisData: any[];

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  types = [];
  PositionsInsidePassengersArea = [];
  days = {
    1: 'Lundi',
    2: 'Mardi',
    3: 'Mercredi',
    4: 'Jeudi',
    5: 'Vendredi'
  };
  // ----- End Option Scrollbar -----------

  // ----- Start MultiSelect -----------
  // Settings configuration
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 0,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block'
  };
  // Text configuration
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a été trouvé...',
    searchNoRenderText: 'Tapez dans la boîte de recherche pour voir les résultats ...',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  // Labels / Parents
  // ----- End MultiSelect -----------

  optionsModelBus: number[];
  multiSelectBus: IMultiSelectOption[];

  optionsModelPassengers: number[];
  multiSelectPassengers: IMultiSelectOption[];

  optionsModelJourney: number[];
  multiSelectJourney: IMultiSelectOption[];

  isResponsible = false;


  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private roleService: NgxRolesService
  ) {
    let date = new Date();
    let day = moment().day();
    if (day == 0) {
      date.setDate(date.getDate() - 2);
    } else if (day == 6) {
      date.setDate(date.getDate() - 1);
    }
    this.filter.date = date;
    // fill schools in multiselect
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
    this.fillSchool();
    this.initZoneAnalysis();

    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
  }

  ngOnInit() {
    this.journeyTypeData = [
      { id: 'M1', text: 'Aller (Matin)' },
      { id: 'M2', text: 'Retour (Matin)' },
      { id: 'AM1', text: 'Aller (Après-midi)' },
      { id: 'AM2', text: 'Retour (Après-midi)' }
    ];
  }


  initZoneAnalysis(){
    this.raduisData = [
                      { id: '40', text: '40 m'},
                      { id: '50', text: '50 m'},
                      { id: '60', text: '60 m'},
                      { id: '70', text: '70 m'},
                      { id: '80', text: '80 m'},
                      { id: '90', text: '90 m'},
                      { id: '100', text: '100 m'},
                      { id: '110', text: '110 m'}
                      ];
  }

  journeyTypeChanged(e: any) {
    this.filter.journeyType = e.value;
  }


  initMap() {
    
    this.center = { lat: 33.906203, lng: -6.9299658 };
    var schoolName = '';
    this.directionsService    = new google.maps.DirectionsService;
    this.directionsRenderer   = new google.maps.DirectionsRenderer({ suppressMarkers: true });

    for (var i = 0; i < this.schools.length; i++) {
      if (this.filter.schoolId == this.schools[i].id) {
        this.center = { lat: parseFloat(this.schools[i].lat), lng: parseFloat(this.schools[i].lng) };
        schoolName = this.schools[i].name;
        break;
      }
    }

    // map
    this.map = new google.maps.Map(document.getElementById('bus-map'), {
      zoom: 10,
      center: this.center,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    this.directionsRenderer.setMap(this.map);

    this.markerBounds = new google.maps.LatLngBounds();
    // school marker
    const schoolInfowindow = new google.maps.InfoWindow({
      content: '<b>École : </b>' + schoolName
    });
    const schoolMarker = new google.maps.Marker({
      position: this.center,
      map: this.map,
      icon: 'assets/images/markers/school.png',
      // zIndex: 99
    });
    // this.markerBounds.extend(this.center);
    schoolMarker.addListener('click', function () {
      schoolInfowindow.open(this.map, schoolMarker);
    });
    schoolMarker.addListener('mouseover', function() {
      schoolInfowindow.open(this.map, schoolMarker);
    });
    schoolMarker.addListener('mouseout', function() {
      schoolInfowindow.close();
    });

    if (this.withZones) {
      // show all polygons in the map
      for (let i = 0; i < this.schools[0].zonesOfService.length; i++) {
            
        // for Dynamic Zone
        if (this.schools[0].zonesOfService[i].coordZone != 0 && this.schools[0].zonesOfService[i].coordZone != null){
          // init with existe param when it's a zone edit
          
          //`coordinatesString` is the value retrieved from your database
          const storedCoordinatesString = this.schools[0].zonesOfService[i].coordZone;

          // Parse the JSON string into an array of coordinates
          const storedCoordinates = JSON.parse(storedCoordinatesString) as { lat: number, lng: number }[];

          //const color = this.getBusColor(this.school.zonesOfService[i].Bus.)
          
          // Draw the saved polygon on the map
          this.drawSavedPolygon(this.schools[0].zonesOfService[i].name,storedCoordinates,this.schools[0].zonesOfService[i].Bus,i);
        }
      }
    }
    
  }

  // Function to draw a polygon on the map
  drawSavedPolygon(zoneName,coordinates: { lat: number, lng: number }[],Bus,polygonId) {
    const polygon = new google.maps.Polygon({
      paths: coordinates,
      strokeColor: Bus.colorLineBus,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: Bus.colorLineBus,
      fillOpacity: 0.35,
      editable: false, // You can set this to false if you don't want the polygon to be editable
      map: this.map
    });

    // Add custom property to store the ID of the polygon
    polygon.polygonId = polygonId;

    // Create an InfoWindow instance
    const infoWindow = new google.maps.InfoWindow();

    // Add click event listener to toggle editable state
    google.maps.event.addListener(polygon, 'click', (event) => {
      
      // Set the content of the InfoWindow
      infoWindow.setContent(`
          <div><strong>Zone :</strong> ${zoneName}</div>
          <div><strong>Bus :</strong> ${Bus.name}</div>
          <div><strong>Chauffeur :</strong> ${Bus.driverName}</div>
        `);

      // Set the position of the InfoWindow
      infoWindow.setPosition(event.latLng);

      // Open the InfoWindow
      infoWindow.open(this.map);
      
    });

  }

  fillSchool() {
    // add schools in multiselect
    let client = this.auth.getUser();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      client = this.auth.getUser().School.Client;
    }
    let params = new HttpParams({
      fromObject: {
        clientId: client.id,
      }
    });
    this.http.get('/api/school/lookup', { params })
      .subscribe(
        (schools: any[]) => {
          if (schools.length) {
            this.schools = schools;
            this.schoolsData = this.schools.map(function (school, index) {
              return { id: school.id, text: school.name };
            });
            this.buses = [];
            this.journeys = [];
            // this.filter.schoolId = this.schools[0].id;
            // this.initMap();
            // this.fillbus();
          }

        }
      );
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initMap();
    this.fillBus();
  }

  onSchoolChange() {
    this.fillBus();
  }

  onJourneyChange() {
    this.fillPassenger();
  }

  onBusChange() {
    this.fillJourney();
  }

  fillBus() {
    this.optionsModelBus = [];
    let client = this.auth.getUser();
    let schoolId = this.filter.schoolId;
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      client = this.auth.getUser().School.Client;
      schoolId = this.auth.getUser().School.id;
    }
    const params = new HttpParams({
      fromObject: {
        clientId: client.id,
        schoolId: schoolId + ''
      }
    });
    this.http.get('/api/bus/lookup', { params })
      .subscribe(
        (bus: any[]) => {
          this.multiSelectBus = bus;
          if (this.multiSelectBus.length) {
            for (let i = 0; i < this.multiSelectBus.length; i++) {
              this.optionsModelBus.push(this.multiSelectBus[i].id);
              this.filter.busIds.push(this.multiSelectBus[i].id);
            }
          }
        }
      );
  }

  fillPassenger() {
    this.optionsModelPassengers = [];
    let client = this.auth.getUser();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      client = this.auth.getUser().School.Client;
    }
    const params = new HttpParams({
      fromObject: {
        clientId: client.id,
        schoolId: this.filter.schoolId + '',
        busIds: JSON.stringify(this.optionsModelBus),
        //journeyIds: JSON.stringify(this.optionsModelJourney),
        isPositionValide: 'true',
        //isAssistant: 'false',
        isActive: 'true',
      }
    });

    this.http.get('/api/passenger/lookup', { params })
      .subscribe(
        (passengers: any) => {
          passengers = passengers.rows.map((passenger) => {
            return {
              id: passenger.id,
              name: passenger.lastname
            };
          });
          this.multiSelectPassengers = passengers;
          if (this.multiSelectPassengers.length) {
            for (let i = 0; i < this.multiSelectPassengers.length; i++) {
              this.optionsModelPassengers.push(this.multiSelectPassengers[i].id);
              this.filter.busIds.push(this.multiSelectPassengers[i].id);
            }
            if (this.onLoadFilter) {
              this.onFilter();
              this.onLoadFilter = false;
            }
            this.loadData = false;
          }
        }
      );
  }

  fillJourney() {
    this.optionsModelJourney = [];
    let client = this.auth.getUser();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      client = this.auth.getUser().School.Client;
    }
    const params = new HttpParams({
      fromObject: {
        clientId: client.id,
        schoolId: this.filter.schoolId + '',
        journeyType: this.filter.journeyType,
        busIds: JSON.stringify(this.optionsModelBus)
      }
    });

    this.http.get('/api/journey/lookup', { params })
      .subscribe(
        (journeys: any[]) => {
          let day = 0;
          const journeysArr = [];
          for (var i = 0; i < journeys.length; i++) {
            if (day != Number(journeys[i].day)) {
              journeysArr.push({
                id: this.days[journeys[i].day],
                name: this.days[journeys[i].day],
                isLabel: true
              });
              day = journeys[i].day;
            }
            journeysArr.push(journeys[i]);
          }
          console.log(journeysArr);

          this.multiSelectJourney = journeysArr;
          const unique = (names) => names.filter((v, i) => names.indexOf(v) === i);
          if (journeys.length) {
            for (let i = 0; i < journeys.length; i++) {
              this.optionsModelJourney.push(journeys[i].id);
            }
            journeys.forEach(journey => {
              this.types.push(journey.type);
            });
          }

          this.journeyTypeData = [
            { id: 'M1', text: 'Départ (Matin)', disabled: !unique(this.types).includes('M1') },
            { id: 'M2', text: 'Retour (Matin)', disabled: !unique(this.types).includes('M2') },
            { id: 'AM1', text: 'Départ (Après-midi)', disabled: !unique(this.types).includes('AM1') },
            { id: 'AM2', text: 'Retour (Après-midi)', disabled: !unique(this.types).includes('AM2') }
          ];
        }
      );
  }

  onFilter() {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    this.loadData = true;
    this.initMap();

    if (this.filter.schoolId != 0 && this.filter.busIds.length > 0) {
      const params = new HttpParams({
        fromObject: {
          schoolId: this.filter.schoolId + '',
          busIds: JSON.stringify(this.optionsModelBus),
          passengerIds: JSON.stringify(this.optionsModelPassengers),
          history: this.filter.history + '',
          date: moment(this.filter.date).format('YYYY-MM-DD'),
          //journeyType: this.filter.journeyType,
          //journeyIds: JSON.stringify(this.optionsModelJourney),
          timeInterval: JSON.stringify(this.filter.timeInterval)
        }
      });
      this.getDataFilter(params);
    }

  }

  getDataFromBus(id) {
    return function (element) {
      return element.busId === id;
    };
  }

  getDataFromJourney(id) {
    return function (element) {
      return element.journeyId === id;
    };
  }

  getElapsedSecondsInDay(date) {
    const day = moment(date);
    const startOfDay = day.clone().startOf('day');
    return day.diff(startOfDay, 'seconds');
  }

  changeTimeJourney(){
    const inputFrom = this.getElapsedSecondsInDay(this.filter.inputFrom);
    const inputTo   = this.getElapsedSecondsInDay(this.filter.inputTo);
    if (inputFrom > inputTo) {
      this.filter.inputTo = '';
    } else {
      this.filter.timeInterval = [inputFrom, inputTo];
    }
  }

  getDataFilter(params) {

    this.http.get('/api/passenger/map', { params })
      .subscribe(
        (data: any) => {
          // if (!data.positions.length) {
          //   this.loadData = false;
          // }
          this.loadData = false;
          // fitch date to get bus
          this.selectedPassengers = [];
          this.stopsWaitingTime = [];
          this.stopsRealArrivalTime = [];
          this.stopsName = [];

          for (let index = 0; index < data.buses.length; index++) {

            const passengers = data.passengers.filter(this.getDataFromBus(data.buses[index].id));

            for (let i = 0; i < passengers.length; i++){
              this.selectedPassengers.push(passengers[i]);
            }

            const positions = data.positions.filter(this.getDataFromBus(data.buses[index].id));

            // Create Passengers
            this.createPassengers(data.buses[index], passengers, this.map);

            if (positions.length > 0) {
              const color = this.getRandomColor(index);
              //this.createLineBus(data.buses[index], positions, this.map, color);
              this.createLineBus(data.buses[index], positions, this.map);
              this.getWaitingDuration(positions,passengers);
              //this.drawMarkerInsideZones(data.buses[index],this.map, color);
            }

          }
          // Only call fitBounds if markerBounds has been extended
          if (!this.markerBounds.isEmpty()) {
            this.map.fitBounds(this.markerBounds);
          } else {
            this.markerBounds.extend(this.center);
            this.map.fitBounds(this.markerBounds);
          }
          

        },
        error => {
          this.loadData = false;
        }
      );
  }


  createLineBus(bus, locations, map) {

    const infowindow = new google.maps.InfoWindow();
  
    const path = [];
  
    for (let i = 0; i < locations.length; i++) {
      const isFirst = i === 0;
      const isLast = i === locations.length - 1;
      const pos = new google.maps.LatLng(parseFloat(locations[i].lat), parseFloat(locations[i].lng));
      path.push(pos);
  
      let content = '';
      let label = null;
      let icon = null;
  
      if (isFirst && i === 0) {
        content = '<h1 style="text-align: center;">Départ</h1>';
        label = 'D';
      } else if (isLast && i === locations.length - 1) {
        content = '<h1 style="text-align: center;">Arrivée</h1>';
        label = 'A';
      } 
  
      // Create an icon for speed === 0 and for directional if withDirection is true
      if (locations[i].speed === 0) {
        icon = {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 6,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          fillColor: '#F00',
          fillOpacity: 0.9
        };
      } else if (this.withDirection) {
        // Only create markers with directional icons if withDirection is true
        icon = {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          scale: 4.5,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          fillColor: bus.colorLineBus,
          fillOpacity: 0.9,
          rotation: locations[i].angle
        };
      }
  
      // Draw a marker if this.withDirection is true, or it's the first/last point, or speed === 0
      if (this.withDirection || isFirst || isLast || locations[i].speed === 0) {
        const marker = new google.maps.Marker({
          position: pos,
          map: map,
          label: label,
          icon: icon
        });
  
        // Marker event listeners are added only if a marker exists
        marker.addListener('click', function () {
          const position = locations[i].lat + ',' + locations[i].lng;

          content = `<b>Bus :</b> ${bus.name}<br/>
          <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
          <b>Position :</b> ${position} <br/>
          <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;

          if (locations[i].BusEvent) {
            content += `<b>Message :</b> ${locations[i].BusEvent.message}`;
          }

          infowindow.setContent(content);
          infowindow.open(map, marker);
        });
  
        marker.addListener('mouseover', function() {
          content = `<b>Bus :</b> ${bus.name}<br/>
          <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
          <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;
  
          if (locations[i].BusEvent) {
            content += `<b>Message :</b> ${locations[i].BusEvent.message}`;
          }
  
          infowindow.setContent(content);
          infowindow.open(map, marker);
        });
  
        marker.addListener('mouseout', function() {
          infowindow.close();
        });
  
        if (isFirst || isLast) {
          google.maps.event.addListener(marker, 'click', (function (marker_, i_) {
            return function () {
              infowindow.setContent(content);
              infowindow.open(map, marker_);
            };
          })(marker, i));
        }
  
        if (isLast) {
          this.loadData = false;
        }
      }
    }
  
    const poly = new google.maps.Polyline({
      path: path,
      geodesic: true,
      strokeColor: bus.colorLineBus,
      strokeOpacity: 0.8,
      strokeWeight: 3,
    });
    poly.setMap(map);
  }
  


  createPassengers(bus, passengers, map) {

    const infowindow = new google.maps.InfoWindow();
    //const markers = [];
    this.markers = [];
    let icon : any;
    const offsets = this.buildSpiderfyOffsets(passengers);
    for (let i = 0; i < passengers.length; i++) {
      if (passengers[i].isPositionValide) {
        const realPos = new google.maps.LatLng(passengers[i].lat, passengers[i].lng);
        const off = offsets[i];
        const pos = off ? new google.maps.LatLng(off.lat, off.lng) : realPos;
        if (passengers[i].isAssistant) {
          icon = 'assets/images/markers/Assistant_Home.png';
        } else {
          //icon = 'assets/images/markers/passenger.png';
          icon = {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 8,
            fillColor: bus ? bus.colorLineBus : '#000', // Black color if Bus doesn't exist
            fillOpacity: 1,
            strokeWeight: 2,
            strokeColor: '#fff', // Use Bus color if it exists
          };
        }
        const marker = new google.maps.Marker({
          position: pos,
          map: map,
          icon: icon,
          passengerId: passengers[i].id,
          schoolId: this.staticFilter.schoolId,
          history: this.staticFilter.history,
          date: moment(this.staticFilter.date).format('YYYY-MM-DD'),
        });
        this.markers.push(marker);
        this.markerBounds.extend(pos);

        const _this = this;
        google.maps.event.addListener(marker, 'click', ((marker, i) => {
          return function () {

            _this.getNotivfication(passengers[i], bus, map, marker, infowindow);

          };
        })(marker, i));

        if (this.filter.history){
          const yourcircle = new google.maps.Circle({
            strokeColor: "#FF0000",
            strokeOpacity: .8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.2,
            map: map,
            center:  realPos,
            radius: parseInt(this.filter.raduis, 10),
          });
        }
        
      }
    }
    // window.alert(markers.length);
    // const markerCluster = new MarkerClusterer (map, markers, {imagePath: 'assets/images/markers/m'});
  }

  /**
   * Compute small circular offsets for items sharing the exact same position,
   * so overlapping markers stay individually visible/clickable.
   * Returns an array aligned with `items` (null = no offset needed).
   */
  buildSpiderfyOffsets(items: any[]): ({ lat: number, lng: number } | null)[] {
    const offsets: ({ lat: number, lng: number } | null)[] = items.map(() => null);
    const groups: { [key: string]: number[] } = {};
    items.forEach((it, idx) => {
      const lat = Number(it.lat);
      const lng = Number(it.lng);
      const key = (isNaN(lat) ? 0 : lat.toFixed(6)) + ',' + (isNaN(lng) ? 0 : lng.toFixed(6));
      (groups[key] = groups[key] || []).push(idx);
    });
    for (const key in groups) {
      const idxs = groups[key];
      if (idxs.length <= 1) continue;
      const baseLat = Number(items[idxs[0]].lat);
      const baseLng = Number(items[idxs[0]].lng);
      const angleStep = (2 * Math.PI) / idxs.length;
      const radius = 0.0003;
      idxs.forEach((idx, k) => {
        const angle = angleStep * k;
        offsets[idx] = {
          lat: baseLat + radius * Math.cos(angle),
          lng: baseLng + radius * Math.sin(angle)
        };
      });
    }
    return offsets;
  }

  getNotivfication(passengers, bus, map, marker, infowindow) {
    const params = new HttpParams({
      fromObject: {
        passengerId: marker.get('passengerId'),
        schoolId: marker.get('schoolId'),
        history: marker.get('history'),
        date: marker.get('date')
      }
    });
    this.http.get('/api/passenger/notification', { params }).subscribe((data: any) => {

      /* const content = `<b>Nom : </b>${passengers.lastname}<br />
        <b>Prénoms : </b>${passengers.firstnames}<br />
        <b>Bus : </b>${bus.name}<br />
        <b>Notifications : </b><br />
        <b> - Départ Matin : </b>  ${ (data.am1 != null) ? moment(data.am1.date).format('HH:mm') : '--:--'} <br />
        <b> - Retour Matin : </b> ${ (data.am2 != null) ? moment(data.am2.date).format('HH:mm') : '--:--'}  <br />
        <b> - Départ AM : </b>  ${ (data.pm1 != null) ? moment(data.pm1.date).format('HH:mm') : '--:--'} <br />
        <b> - Retour AM : </b> ${ (data.pm2 != null) ? moment(data.pm2.date).format('HH:mm') : '--:--'}  <br />`;
 */
        const content = `<b>Nom : </b>${passengers.lastname}<br />
        <b>Prénoms : </b>${passengers.firstnames}<br />
        <b>Bus : </b>${bus.name}<br />`;
      infowindow.setContent(content);
      infowindow.open(map, marker);
    });
  }

  getWaitingDuration (busPositions, passengers){

    let tempDistance = 0;
    let tempPositionsInside = [];

    passengers.forEach((passenger, index) => {
      tempPositionsInside = [];
      this.PositionsInsidePassengersArea = [];

      
      this.stopsName.push(passenger.lastname+ '-' +passenger.firstnames);
      
      // 1- On cherche positions inside raduis with home position is the center
      for (let i = 0; i < busPositions.length; i++) {

        tempDistance = this.getDistanceInMeter(passenger.lat, passenger.lng,busPositions[i].lat,busPositions[i].lng);
        if (tempDistance < parseInt(this.filter.raduis, 10) && busPositions[i].speed < 7){
          tempPositionsInside.push(busPositions[i]);
          this.PositionsInsidePassengersArea.push(busPositions[i]);
          console.log ("Position in ==> "+i);
        }
      }

      // 2- On calcule la durée max
      if (tempPositionsInside.length > 0) {

        this.stopsRealArrivalTime.push(moment.utc(tempPositionsInside[0].time).format('HH:mm')+'');

        let dt1_string = moment.utc(tempPositionsInside[0].time).format('HH:mm:ss')+'';
        let dt2_string = moment.utc(tempPositionsInside[tempPositionsInside.length-1].time).format('HH:mm:ss')+'';

        let diff_time = this.diffenceTime (dt2_string,dt1_string);

        if (diff_time > 60) {
          diff_time /= 60;
          //console.log(Math.round(diff_time)+ ' min');
          this.stopsWaitingTime.push(Math.round(diff_time)+ ' min');
        } else if (diff_time == 0) {
          //console.log('moins de 10 sec');
          this.stopsWaitingTime.push('moins de 10 sec');
        } else {
          //console.log(diff_time+ ' sec');
          this.stopsWaitingTime.push(diff_time+ ' sec');
        }

      } else {
        this.stopsRealArrivalTime.push('--:--');
        this.stopsWaitingTime.push('-');
      }
    });
    //console.log('stopsWaitingTime');
    //console.log(this.stopsWaitingTime);
    //console.log(this.stopsRealArrivalTime);
    //console.log(this.selectedPassengers);
  }

  getDistanceInMeter (latCenter, longCenter, lat, lng ){
    return Math.acos( Math.sin(latCenter*Math.PI/180)*Math.sin(lat*Math.PI/180) + Math.cos(latCenter*Math.PI/180)*Math.cos(lat*Math.PI/180)*Math.cos(lng*Math.PI/180-longCenter*Math.PI/180) ) * 6371000;
  }

  diffenceTime (dt2_string,dt1_string){
    let dt1 = new Date();
    let dt2 = new Date();
    let value_dt1 = (dt1_string+":00").split(':');
    let value_dt2 = (dt2_string+":00").split(':');

    dt1.setHours(parseInt(value_dt1[0], 10), parseInt(value_dt1[1], 10), parseInt(value_dt1[2], 10), 0);
    dt2.setHours(parseInt(value_dt2[0], 10), parseInt(value_dt2[1], 10), parseInt(value_dt2[2], 10), 0);

    let diff =(dt2.getTime() - dt1.getTime()) / 1000;

    return Math.abs(Math.round(diff));// difference in second
  }

  drawMarkerInsideZones (bus,map,color){

    const infowindow = new google.maps.InfoWindow();

    console.log (this.PositionsInsidePassengersArea);
    for (let i = 0; i < this.PositionsInsidePassengersArea.length; i++) {
      
      console.log ("==> "+i);
      const pos = new google.maps.LatLng(parseFloat(this.PositionsInsidePassengersArea[i].lat), parseFloat(this.PositionsInsidePassengersArea[i].lng));
    
      let content = '';
      let label = null;
      let icon = null;
      if (this.PositionsInsidePassengersArea[i].speed === 0) {
        icon = {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 6,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          fillColor: '#F00',
          fillOpacity: 0.9
        };
      } else {
        icon = {
          // url: this.createMarkerColored(color, locations[i].BusEvent),
          // origin: new google.maps.Point(0, 0),
          // anchor: new google.maps.Point(15, 15),
          // flat: true
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          scale: 4.5,
          strokeColor: '#ffffff',
          strokeWeight: 2,
          fillColor: bus.colorLineBus,
          fillOpacity: 0.9,
          rotation: this.PositionsInsidePassengersArea[i].angle
        };
      }
      
      const marker = new google.maps.Marker({
        position: pos,
        map: map,
        label: label,
        icon: icon
      });
      // this.markerBounds.extend(pos);

      marker.addListener('click', function () {
        const position = this.PositionsInsidePassengersArea[i].lat + ',' + this.PositionsInsidePassengersArea[i].lng;

        content = `<b>Bus :</b> ${bus.name}<br/>
        <b>Date :</b> ${ moment.utc(this.PositionsInsidePassengersArea[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
        <b>Position :</b> ${position} <br/>
        <b>Vitesse :</b> ${this.PositionsInsidePassengersArea[i].speed} km/h<br/>`;

        content += (this.PositionsInsidePassengersArea[i].BusEvent) ? `<b>Message :</b> ${this.PositionsInsidePassengersArea[i].BusEvent.message}` : '';

        infowindow.setContent(content);
        infowindow.open(map, marker);
      });

      marker.addListener('mouseover', function() {
        content = `<b>Bus :</b> ${bus.name}<br/>
        <b>Date :</b> ${ moment.utc(this.PositionsInsidePassengersArea[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
        <b>Vitesse :</b> ${this.PositionsInsidePassengersArea[i].speed} km/h<br/>`;

        content += (this.PositionsInsidePassengersArea[i].BusEvent) ? `<b>Message :</b> ${this.PositionsInsidePassengersArea[i].BusEvent.message}` : '';

        infowindow.setContent(content);
        infowindow.open(map, marker);
      });
      marker.addListener('mouseout', function() {
        infowindow.close();
      });
      
    }
  }


  zoneAnalysisChanged(e: any) {
    this.filter.raduis = e.value;
    console.log("Raduis: " + this.filter.raduis );
  }

  displayPosition(i:any) {
      const center = new google.maps.LatLng(this.selectedPassengers[i].lat, this.selectedPassengers[i].lng);
      this.map.setCenter(center);
      this.map.setZoom(18);
  }

  getRandomColor(i) {
    return this.reservedColors[i % 9];
  }


  createMarkerColored(color) {
    const width = 15;
    const height = 15;
    const radius = 8;
    let canvas, context1;

    canvas = document.createElement("canvas");
    context1 = canvas.getContext("2d");
    canvas.width = width * 2;
    canvas.height = height * 2;

    context1.fillStyle = color;
    context1.strokeStyle = '#fff';
    context1.beginPath();
    context1.arc(width, height, radius, 0, 2 * Math.PI);
    context1.lineWidth = 3;
    context1.closePath();
    context1.fill();
    context1.stroke();

    return canvas.toDataURL();

  }

  dateTimeFilterWE(d: moment.Moment) {
    const day = d.day();
    return day !== 0 && day !== 6;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/passenger/passenger-map/passenger-map.component.ts